export default "__VITE_ASSET__CSOEAk0M__"